var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.624,
    height: 33.041,
    viewBox: "0 0 33.624 33.041",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-check-circle",
    "data-name": "Icon feather-check-circle",
    transform: "translate(-1.497 -1.473)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M33,16.62V18A15,15,0,1,1,24.105,4.29",
    fill: "none",
    stroke: "#b92c82",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M33,6,18,21.015l-4.5-4.5",
    fill: "none",
    stroke: "#b92c82",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircle);
export default __webpack_public_path__ + "static/media/check-circle.c5fde43e3ba261fab8df57b6ccee5fcd.svg";
export { ForwardRef as ReactComponent };